import Collapse from 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import lozad from 'lozad'
//import AOS from 'aos';
//import 'aos/dist/aos.css';
import './contact';
//import './cookies';
import './swiper';
import './views';
import './darkmode';
import './gallery';

function initHomeAnchorNavigation() {
    const navbar = document.querySelector('.navbar[data-home-url]');

    if (!navbar) return;

    const navLinks = Array.from(navbar.querySelectorAll('.navbar-nav .nav-link'));
    const anchorLinks = Array.from(navbar.querySelectorAll('[data-home-anchor-link]'));

    if (anchorLinks.length === 0) return;

    const homeUrl = new URL(navbar.dataset.homeUrl, window.location.origin);
    const normalizePath = (path) => {
        const normalizedPath = path.replace(/\/+$/, '');
        return normalizedPath === '' ? '/' : normalizedPath;
    };
    const homePath = normalizePath(homeUrl.pathname);
    const getCurrentPath = () => normalizePath(window.location.pathname);

    const anchors = anchorLinks
        .map((link) => {
            const url = new URL(link.getAttribute('href'), window.location.origin);
            const hash = url.hash;

            if (!hash) return null;

            const target = document.getElementById(decodeURIComponent(hash.slice(1)));

            if (!target) return null;

            return { link, hash, target, path: normalizePath(url.pathname) };
        })
        .filter(Boolean);

    if (anchors.length === 0) return;

    const clearActiveState = () => {
        navLinks.forEach((link) => {
            link.classList.remove('active');
            link.removeAttribute('aria-current');
            link.closest('.nav-item')?.classList.remove('current-menu-item', 'current_page_item', 'current-menu-ancestor', 'current-menu-parent', 'current_page_parent');
        });
    };

    const setActiveState = (activeAnchor) => {
        clearActiveState();

        if (!activeAnchor) return;

        activeAnchor.link.classList.add('active');
        activeAnchor.link.setAttribute('aria-current', 'page');
        activeAnchor.link.closest('.nav-item')?.classList.add('current-menu-item', 'current_page_item');
    };

    const isHomepage = () => getCurrentPath() === homePath;
    const getOffset = () => (document.querySelector('.header')?.offsetHeight || 0) + 32;

    const findAnchorByHash = (hash) => anchors.find((anchor) => anchor.hash === hash && anchor.path === homePath) || null;
    const getHomepageAnchors = () => anchors.filter((anchor) => anchor.path === homePath);

    const updateActiveState = () => {
        if (!isHomepage()) {
            return;
        }

        const offset = getOffset();
        const homepageAnchors = getHomepageAnchors();
        let activeAnchor = null;
        let closestDistance = Number.POSITIVE_INFINITY;

        homepageAnchors.forEach((anchor) => {
            const top = anchor.target.getBoundingClientRect().top;
            const distance = top - offset;

            if (distance <= 0 && Math.abs(distance) < closestDistance) {
                activeAnchor = anchor;
                closestDistance = Math.abs(distance);
            }
        });

        if (!activeAnchor && window.location.hash) {
            activeAnchor = findAnchorByHash(window.location.hash);
        }

        if (!activeAnchor) {
            const firstVisibleAnchor = homepageAnchors.find((anchor) => {
                const rect = anchor.target.getBoundingClientRect();

                return rect.top < window.innerHeight && rect.bottom > offset;
            });

            if (firstVisibleAnchor) {
                activeAnchor = firstVisibleAnchor;
            }
        }

        setActiveState(activeAnchor);
    };

    let isTicking = false;

    const requestUpdate = () => {
        if (isTicking) return;

        isTicking = true;

        window.requestAnimationFrame(() => {
            updateActiveState();
            isTicking = false;
        });
    };

    anchorLinks.forEach((link) => {
        link.addEventListener('click', () => {
            const url = new URL(link.getAttribute('href'), window.location.origin);
            const clickedAnchor = findAnchorByHash(url.hash);

            if (clickedAnchor && isHomepage()) {
                setActiveState(clickedAnchor);
            }

            window.requestAnimationFrame(updateActiveState);
        });
    });

    window.addEventListener('hashchange', updateActiveState);
    window.addEventListener('load', updateActiveState);
    window.addEventListener('resize', requestUpdate);
    window.addEventListener('scroll', requestUpdate, { passive: true });

    updateActiveState();
    window.requestAnimationFrame(updateActiveState);
}

function initMobileNavigation() {
    const navbar = document.querySelector('.navbar');
    const toggler = navbar?.querySelector('.navbar-toggler');
    const collapse = navbar?.querySelector('.navbar-collapse');

    if (!navbar || !toggler || !collapse) return;

    const collapseInstance = Collapse.getOrCreateInstance(collapse, { toggle: false });

    const closeMobileMenu = () => {
        if (window.matchMedia('(min-width: 1300px)').matches) return;
        if (!collapse.classList.contains('show')) return;

        collapseInstance.hide();
    };

    collapse.querySelectorAll('.nav-link, .btn').forEach((link) => {
        link.addEventListener('click', closeMobileMenu);
    });
}

function initAutoHideHeader() {
    const header = document.querySelector('.header');

    if (!header) return;

    const collapse = header.querySelector('.navbar-collapse');
    let lastScrollY = window.scrollY;
    let isTicking = false;

    const setHeaderHeight = () => {
        document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
    };

    const isMenuOpen = () => collapse?.classList.contains('show') || collapse?.classList.contains('collapsing');

    const showHeader = () => {
        header.classList.remove('header--hidden');
    };

    const updateHeader = () => {
        const currentScrollY = Math.max(window.scrollY, 0);
        const scrollDelta = currentScrollY - lastScrollY;
        const threshold = 8;

        header.classList.toggle('header--scrolled', currentScrollY > 16);

        if (currentScrollY <= 16 || isMenuOpen()) {
            showHeader();
        } else if (scrollDelta > threshold) {
            header.classList.add('header--hidden');
        } else if (scrollDelta < -threshold) {
            showHeader();
        }

        lastScrollY = currentScrollY;
        isTicking = false;
    };

    const requestHeaderUpdate = () => {
        if (isTicking) return;

        isTicking = true;
        window.requestAnimationFrame(updateHeader);
    };

    setHeaderHeight();
    updateHeader();

    window.addEventListener('resize', () => {
        setHeaderHeight();
        requestHeaderUpdate();
    });
    window.addEventListener('load', setHeaderHeight);
    window.addEventListener('scroll', requestHeaderUpdate, { passive: true });

    collapse?.addEventListener('show.bs.collapse', showHeader);
    collapse?.addEventListener('shown.bs.collapse', showHeader);
}

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => new Tooltip(el));
    const observer = lozad('[data-src]');
    observer.observe();

    // Initialize AOS
    AOS.init({
        duration: 800,
        easing: 'ease-in-out',
        once: true,
        offset: 100,
        delay: 50,
    });

    initHomeAnchorNavigation();
    initMobileNavigation();
    initAutoHideHeader();
});


document.addEventListener('scroll', function () {
    const images = document.querySelectorAll('[data-src]');
    const observer = lozad();
    observer.observe();

    images.forEach(function (image) {
        observer.triggerLoad(image);
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const masonryContainer = document.querySelector('#testimonials-grid');

    if (!masonryContainer) return;

    const testimonialItems = masonryContainer.querySelectorAll('.testimonial-item');

    if (testimonialItems.length === 0) return;

    const showMoreBtn = document.querySelector('#show-more-testimonials');

    if (showMoreBtn) {
        showMoreBtn.addEventListener('click', () => {
            testimonialItems.forEach(item => item.classList.remove('d-none'));

            masonryContainer.classList.add('expanded');

            showMoreBtn.classList.add('d-none');

        });
    }
});
